<template>
  <v-container fluid>
    <v-row no-gutters class="mt-2 mb-3">
      <v-col cols="12" md="9">
        <h2>
          {{ pazymaTitle
          }}<el-tooltip
            inline
            :tooltip="aprasymasTooltip"
            external
            @activate="
              eventPayload => showAprasymas(eventPayload, aprasymasTooltip)
            "
          />
        </h2>
      </v-col>
      <v-col cols="12" md="3" class="text-right">
        <el-button v-if="showToList" @click.native="toList()" x-small>{{
          $t('Grįžti į sąrašą')
        }}</el-button>
        <el-prasymas-busena
          class="busena-active mt-1"
          :busena="pazymaBusenaTitle"
        />
      </v-col>
    </v-row>
    <div class="paslauga-aprasymas">
      <el-paslauga-aprasymas
        :tooltip="paslaugaAprasymas"
        @close="hideAprasymas"
      />
    </div>

    <check-errors ntr-paslaugos textOnly />

    <el-overlay-loading :loading="false" :absolute="false" />
    <pazyma-turtas
      v-if="showPazymaTurtas"
      :key="pazymaTurtasKey"
      :pazyma-kodas="pazymaKodas"
      :pazyma="pazyma"
      @loaded="turtasLoaded"
      @updatePazyma="updatePazyma"
    />

    <v-card
      class="ntr-card-gray pt-0 pb-2 px-2 mt-3"
      flat
      v-if="showSkuba || showAsmensDuomenys"
    >
      <v-row dense no-gutters v-if="showAsmensDuomenys">
        <v-col class="bold-label pt-4" cols="12" md="3" align-self="center">
          {{ $t('Asmens kodas')
          }}<el-tooltip
            inline
            :tooltip="`${pazymaTooltipPrefix} Asmens kodas`"
          />
        </v-col>
        <v-col cols="12" md="4">
          <el-text-field
            :readonly="true"
            hide-details="auto"
            validate-key="asm_asmens_kodas"
            v-model="asmuo.asm_asmens_kodas"
          />
        </v-col>
      </v-row>
      <template v-if="isAsmuoFizinis && showAsmensDuomenys">
        <v-row dense no-gutters>
          <v-col class="bold-label pt-4" cols="12" md="3" align-self="center">
            {{ $t('Vardas')
            }}<el-tooltip inline :tooltip="`${pazymaTooltipPrefix} Vardas`" />
          </v-col>
          <v-col cols="12" md="8">
            <el-text-field
              :readonly="true"
              hide-details="auto"
              validate-key="asm_fiz_vardas"
              v-model="asmuo.asm_fiz_vardas"
            />
          </v-col>
        </v-row>
        <v-row dense no-gutters>
          <v-col class="bold-label pt-4" cols="12" md="3" align-self="center">
            {{ $t('Pavardė')
            }}<el-tooltip inline :tooltip="`${pazymaTooltipPrefix} Pavardė`" />
          </v-col>
          <v-col cols="12" md="8">
            <el-text-field
              :readonly="true"
              hide-details="auto"
              validate-key="asm_fiz_pavarde"
              v-model="asmuo.asm_fiz_pavarde"
            />
          </v-col>
        </v-row>
      </template>
      <template v-if="!isAsmuoFizinis && showAsmensDuomenys">
        <v-row dense no-gutters>
          <v-col class="bold-label pt-4" cols="12" md="3" align-self="center">
            {{ $t('Pavadinimas')
            }}<el-tooltip
              inline
              :tooltip="`${pazymaTooltipPrefix} Pavadinimas`"
            />
          </v-col>
          <v-col cols="12" md="8">
            <el-text-field
              :readonly="true"
              hide-details="auto"
              validate-key="asm_pavadinimas"
              v-model="asmuo.asm_pavadinimas"
            />
          </v-col>
        </v-row>
      </template>
      <template v-if="showSkuba">
        <v-row dense no-gutters>
          <v-col class="bold-label pt-4" cols="12" md="3" align-self="center">
            <div style="position: relative;">
              {{ skubaTitle }}<el-need v-if="!isReadonly" />
              <el-tooltip
                inline
                :tooltip="`${pazymaTooltipPrefix} ${skubaTitleTooltip}`"
              />
            </div>
          </v-col>
          <v-col cols="12" md="4">
            <el-autocomplete
              :items="skubos"
              itemvalue="value"
              itemtext="text"
              validate-key="Skuba"
              :readonly="isReadonly"
              hide-details="auto"
              v-model="pazyma.paz_skuba"
              @change="saveData()"
            />
          </v-col>
        </v-row>
      </template>
      <template v-if="showKaina && showAsmensDuomenys">
        <v-row dense no-gutters>
          <v-col class="bold-label pt-4" cols="12" md="3" align-self="center">
            {{ $t('Kaina, Eur')
            }}<el-tooltip
              inline
              :tooltip="`${pazymaTooltipPrefix} Kaina, Eur`"
            />
          </v-col>
          <v-col class="bold-label pt-4" cols="12" md="8">
            {{ kainaFormat }}
          </v-col>
        </v-row>
      </template>
    </v-card>

    <igaliojimai-tab
      v-if="showIgaliojimai"
      :pazyma="pazyma"
      :asmuo="asmuo"
      @loaded="igaliojimaiLoaded"
      @updatePazyma="updatePazyma"
    />

    <modal-confirm
      :title="modalConfirmTitle"
      :text="modalConfirmText"
      :action="modalConfirmAction"
      v-model="showConfirm"
      save-bnt="Mokėti"
      @cancelConfirm="closeConfirm"
      @confirmpazymaRegistruoti="pazymaRegistruoti"
    />

    <v-footer class="form-footer">
      <el-button
        v-if="validate('Užsakyti pažymą')"
        primary
        @click.native="
          veiksmasStatus('pazyma-uzsakymas', 'confirmPazymaUzsakyti')
        "
        :loading="fullLoading"
        >{{ uzsakytiBtnText }}</el-button
      >
      <el-button
        v-if="validate('Mokėti')"
        primary
        @click.native="veiksmasStatus('pazyma-mokejimas', 'pazymaMoketi')"
        :loading="fullLoading"
        >{{ $t('Mokėti') }}</el-button
      >
      <el-button
        v-if="validate('Atšaukti')"
        @click.native="cancelPazyma()"
        :loading="fullLoading"
        >{{ $t('Atšaukti') }}</el-button
      >
      <v-spacer></v-spacer>

      <el-button
        v-if="validate('Tikrinti savitarna')"
        primary
        @click.native="checkPazymaErrors()"
        :loading="fullLoading"
        >{{ $t('Tikrinti') }}</el-button
      >
    </v-footer>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import PazymaMap from './PazymaMap'
import CheckErrors from '../hipoteka/CheckErrors'
import ModalConfirm from '../modals/ModalConfirm'
import PazymaTurtas from './PazymaTurtas'
import IgaliojimaiTab from './igaliojimas/IgaliojimaiTab'
import checkErrors from '@/mixins/checkErrors'
import pazymaVeiksmas from './pazymaVeiksmas'
import pazymaBusena from './pazymaBusena'

export default {
  name: 'Pazyma',
  components: { PazymaTurtas, CheckErrors, IgaliojimaiTab, ModalConfirm },
  mixins: [checkErrors, pazymaBusena, pazymaVeiksmas],
  props: {
    pazymaKodas: String,
  },
  data() {
    return {
      pageloading: true,
      loading: false,
      turtasLoading: false,
      igaliojimaiLoading: false,

      pazyma: {},
      asmuo: {},
      skubos: [],
      paslaugaAprasymas: null,

      modalConfirmTitle: null,
      modalConfirmText: null,
      modalConfirmAction: null,
      showConfirm: false,

      pazymaTurtasKey: 0,
    }
  },
  $_veeValidate: {
    validator: 'new',
  },
  computed: {
    ...mapGetters(['pazymaID', 'listInfo']),
    isReadonlyForm() {
      return this.pazyma.paz_readonly
    },
    isReadonly() {
      return this.isReadonlyForm
    },
    pazymaMap() {
      return PazymaMap.getPazymaTipas(this.pazymaKodas)
    },
    pazymaTipas() {
      return this.pazymaMap.tipas
    },
    isTipasZemes() {
      return this.pazymaTipas === 'zemes-ukio'
    },
    isTipasSklypas() {
      return this.pazymaTipas === 'zemes-sklypas'
    },
    pazymaTitle() {
      return this.pazymaMap.pazymaTitle
    },
    pazymaBusena() {
      return this.pazyma.paz_busena
    },
    pazymaBusenaTitle() {
      return PazymaMap.getPazymaBusena(this.pazymaBusena).title
    },
    pazymaRouteList() {
      return this.pazymaMap.routeList
    },
    showToList() {
      return this.listInfo.pazymaID === this.pazymaID
    },
    aprasymasTooltip() {
      return `${this.pazymaTooltipPrefix} Anotacija`
    },
    skubaTitle() {
      return this.$t('Skuba')
    },
    skubaTitleTooltip() {
      return 'Skuba'
    },
    pazymaTooltipPrefix() {
      return this.pazymaMap.tooltipPrefix
    },
    isAsmuoFizinis() {
      return this.asmuo.tipas === 'FIZ'
    },
    isPazymaTikrinti() {
      return (
        this.pazyma?.paz_igaliojimai?.tipas === 2 ||
        this.pazyma?.paz_igaliojimai?.tipas === 3
      )
    },
    showSkuba() {
      return (
        this.pazyma && this.asmuo && this.pazyma.paz_id && this.isPazymaTikrinti
      )
    },
    showKaina() {
      return this.pazyma.paz_kaina
    },
    kainaFormat() {
      return this.moneyformat(this.pazyma.paz_kaina ?? 0)
    },
    showAsmensDuomenys() {
      return !this.isTipasSklypas
    },

    getConfirmText() {
      let $text = this.pazymaMap.uzsakytiConfirmText
      if (this.isPazymaTikrinti) {
        $text += `<br /><br />${this.pazymaMap.uzsakytiConfirmTikrinti}`
      }

      return $text
    },
    showIgaliojimai() {
      return this.pazyma?.paz_su_igaliojimu
    },
    showPazymaTurtas() {
      return this.isTipasSklypas
    },
    fullLoading() {
      return this.loading || this.turtasLoading || this.igaliojimaiLoading
    },
    uzsakytiBtnText() {
      if (this.isTipasSklypas) {
        return this.$t('Užsakyti')
      }
      return this.$t('Užsakyti pažymą')
    },
  },
  beforeCreate() {
    this.$root.$off('reloadPazyma')
  },
  beforeDestroy() {
    this.$store.dispatch('unlockPaz', {
      paz_id: this.pazymaID,
      lock: false,
    })
  },
  created() {
    this.$root.$on('reloadPazyma', () => {
      this.getData()
    })
    this.$store.dispatch('checkErrors', null)
    this.defaultRouteParams()
    this.turtasLoading = this.showPazymaTurtas
    this.igaliojimaiLoading = true
    this.getData(true)
  },
  methods: {
    defaultRouteParams() {
      if (this.$route.params.pazymaID) {
        this.$store.dispatch('pazymaID', this.$route.params.pazymaID)
      }
    },
    getData(firstLoad = false) {
      this.loading = true

      this.$axios
        .get(`ntrpaslaugos/pazyma/${this.pazymaID}`)
        .then(res => {
          this.pazyma = res.data.pazyma
          this.asmuo = res.data.asmuo
          this.skubos = res.data.skubos
          this.$store.dispatch('pazymaTipas', this.pazyma.paz_tipas)
          this.$store.dispatch('pazymaBusena', this.pazyma.paz_busena)
          this.$store.dispatch('pazymaReadonly', this.pazyma.paz_readonly)

          if (firstLoad) {
            this.igaliojimaiLoading = this.showIgaliojimai
          }

          this.$store.dispatch('lockPaz', {
            paz_id: this.pazymaID,
            lock: !this.paz_readonly,
          })
          this.$store.dispatch('activeTooltip', '')
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    saveData() {
      if (this.isReadonly) {
        return
      }
      this.$validator.validateAll().then(res => {
        if (res) {
          const data = {
            ...this.pazyma,
          }
          this.$axios
            .post(`ntrpaslaugos/pazyma/${this.pazymaID}`, data)
            .then(res => {
              this.getData()
            })
            .catch(err => {
              window._VMA.$emit('DATA_ERROR', err.response.data.message)
            })
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
    saveIgaliojimas(igaliojimas) {
      this.pazyma.paz_igaliojimai = igaliojimas
      this.saveData()
    },
    updatePazyma() {
      this.getData()
    },
    toList() {
      this.$router.push({
        name: this.listInfo.routeName,
        params: {
          toList: true,
        },
      })
    },
    showAprasymas(tipas) {
      this.paslaugaAprasymas = tipas
    },
    hideAprasymas() {
      this.paslaugaAprasymas = null
      this.$store.dispatch('activeTooltip', '')
    },
    confirmPazymaUzsakyti() {
      this.loading = true
      this.modalConfirmTitle = this.pazymaMap.uzsakytiConfirmTitle
      this.modalConfirmText = this.getConfirmText
      this.modalConfirmAction = 'pazymaRegistruoti'
      this.showConfirm = true
    },
    closeConfirm() {
      this.loading = false
      this.showConfirm = false
    },
    pazymaRegistruoti() {
      this.pazymaUzsakyti()
    },
    turtasLoaded() {
      this.turtasLoading = false
    },
    igaliojimaiLoaded() {
      this.igaliojimaiLoading = false
    },
    reloadTurtas() {
      this.pazymaTurtasKey++
    },
  },
}
</script>
<style lang="scss" scoped>
.busena-link {
  display: inline-block;
}
.busena-active {
  cursor: pointer;
}
</style>
